import React, { ButtonHTMLAttributes, FC, SVGProps } from 'react';
import { Text, UnstyledButton } from '@mantine/core';
import classNames from 'classnames';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
	Icon: FC<SVGProps<SVGSVGElement>>;
	label?: string;
}

export const ToolbarButton: React.FC<Props> = ({
	Icon,
	label,
	...buttonProps
}) => {
	return (
		<UnstyledButton
			{...buttonProps}
			className={classNames('toolbar-btn', buttonProps.className)}
		>
			<Icon />
			{!!label && (
				<Text size="xs" fw="bold">
					{label}
				</Text>
			)}
		</UnstyledButton>
	);
};
